import React, { useState } from "react";
import Select from "react-select";

import { client_config } from "../../../utils/clientConfigs";

import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toastr } from "react-redux-toastr";

const DEVICE_TYPE_OPTIONS = ["email", "sms", "voice"].filter(
  (type) => !client_config.disabled_features[type]
);

const WhitelistModal = ({ isOpen, selected, toggleModal, applyChanges }) => {
  const [whitelistRecord, setWhitelistRecord] = useState({
    org_vch: "",
    name_vch: "",
    device_vch: "",
    device_type_vch: DEVICE_TYPE_OPTIONS.length === 1 ? DEVICE_TYPE_OPTIONS[0] : null,
    ...selected,
  });

  const closeBtn = (
    <button type="button" className="close" onClick={toggleModal}>
      &times;
    </button>
  );

  function updateWhitelistRecord({ name, value }) {
    // console.log("Updating", name, "to", value);

    if (/(name|org)/.test(name)) {
      value = value.replace(/[^a-z-'.\s]/i, "");
    }

    setWhitelistRecord({
      ...whitelistRecord,
      [name]: value,
    });
  }

  function validateChanges(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (!whitelistRecord.name_vch) {
      return toastr.error("Oops", "Please specify the contact's name");
    }

    if (!whitelistRecord.device_type_vch) {
      if (whitelistRecord.device_type_vch.value) {
        whitelistRecord.device_type_vch = whitelistRecord.device_type_vch.value;
      }
      return toastr.error("Oops", "Please specify the contact's device type");
    }
    if (!whitelistRecord.device_vch) {
      return toastr.error("Oops", "Please specify the contact information");
    }
    if (!whitelistRecord.org_vch) {
      return toastr.error("Oops", "Please specify the contact's organization");
    }

    if (["sms", "voice"].includes(whitelistRecord.device_type_vch)) {
      whitelistRecord.device_vch = whitelistRecord.device_vch.replace(/[^\d]/g, "");
    }

    applyChanges({
      ...whitelistRecord,
    }).then((success) => {
      success && toggleModal(false);
    });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <form onSubmit={validateChanges} action="#">
        <ModalHeader toggle={toggleModal} close={closeBtn}>
          {whitelistRecord._key ? "Edit" : "Add"} White List Record
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Name</InputGroupText>
                </InputGroupAddon>

                <Input
                  bsSize="lg"
                  type="text"
                  name="name_vch"
                  value={whitelistRecord["name_vch"] || ""}
                  onChange={({ target }) => updateWhitelistRecord(target)}
                  placeholder="Contact Name"
                  required={true}
                />
              </InputGroup>
            </Col>

            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Device Type</InputGroupText>
                </InputGroupAddon>

                {DEVICE_TYPE_OPTIONS.length === 1 ? (
                  <Input
                    bsSize="lg"
                    type="text"
                    name="device_type_vch"
                    value={whitelistRecord["device_type_vch"] || ""}
                    required={true}
                    disabled={true}
                    readOnly={true}
                  />
                ) : (
                  <Select
                    className="flex-fill"
                    value={
                      whitelistRecord["device_type_vch"]
                        ? {
                            label: whitelistRecord["device_type_vch"],
                            value: whitelistRecord["device_type_vch"],
                          }
                        : ""
                    }
                    options={DEVICE_TYPE_OPTIONS.map((type) => ({ label: type, value: type }))}
                    onChange={({ value }) =>
                      updateWhitelistRecord({ name: "device_type_vch", value })
                    }
                    placeholder={DEVICE_TYPE_OPTIONS.join(", ")}
                  />
                )}
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Device</InputGroupText>
                </InputGroupAddon>

                {!whitelistRecord["device_type_vch"] ||
                whitelistRecord["device_type_vch"] === "email" ? (
                  <Input
                    bsSize="lg"
                    type="text"
                    name="device_vch"
                    value={whitelistRecord["device_vch"] || ""}
                    onChange={({ target }) => updateWhitelistRecord(target)}
                    placeholder={
                      whitelistRecord["device_type_vch"]
                        ? "sample@email.com"
                        : "Please select a device type"
                    }
                    required={true}
                    disabled={!whitelistRecord["device_type_vch"]}
                  />
                ) : (
                  <InputMask
                    mask="+1 (999) 999-9999"
                    maskChar={null}
                    value={whitelistRecord["device_vch"] || ""}
                    onChange={({ target }) => updateWhitelistRecord(target)}
                  >
                    {(inputProps) => (
                      <Input
                        bsSize="lg"
                        name="device_vch"
                        placeholder="+1 (123) 456-7890"
                        {...inputProps}
                      />
                    )}
                  </InputMask>
                )}
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Organization</InputGroupText>
                </InputGroupAddon>

                <Input
                  bsSize="lg"
                  type="text"
                  name="org_vch"
                  value={whitelistRecord["org_vch"] || ""}
                  onChange={({ target }) => updateWhitelistRecord(target)}
                  placeholder="Organization Name"
                  required={true}
                />
              </InputGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter className="d-flex justify-content-between">
          <Button type="button" color="secondary" onClick={toggleModal}>
            Cancel
          </Button>

          <Button type="submit" color="primary" onClick={validateChanges}>
            Save
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default WhitelistModal;
